import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/payment-redirect")({
  component: () => (
    <Navigate
      to="/casino"
      search={{
        modal: "profile",
        profileSection: "wallet",
      }}
      replace
    />
  ),
});
